$(document).on("click", ".question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p').removeClass('active');
    jQuery('.question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", ".custom_button", function() {
  var video = $(this).parents('.video_wrapper_custom').find('video').get(0); // Get native video element
  $(this).hide();
  $(this).parents('.video_wrapper_custom').addClass('video-active'); // Corrected class
  if (video) {
    video.play(); // Directly play video
  }
});
$(document).on("click", ".video_wrapper_custom video", function() {
  const video = $(this).get(0); // native DOM video element
  const wrapper = $(this).parents('.video_wrapper_custom');
  const playButton = wrapper.find('.custom_button');

  video.pause(); // actually pause
  playButton.show(); // show play button again
  wrapper.removeClass('video-active');
});


// $(document).on("click", ".custom_button", function (e) {
//     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
// if (jQuery(this).hasClass("active")) {
//    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
//     jQuery(this).removeClass('active');
// video.trigger('pause');
// } else {
// video.trigger('play');
//   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
//     jQuery(this).addClass('active');
// }
// });







$(document).on("click", "a[href='#compare']", function (e) {
  e.preventDefault();
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#judgeme_product_reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.start_count .count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 2000,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });

});



$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});


$(document).on('change', '.custom_options_selector_like .option_select_like', function() {
  const $wrapper = $(this).closest('.custom_options_selector_like');

  // 1️⃣ Collect selected options
  const selectedOptions = [];
  $wrapper.find('.option_select_like').each(function() {
    selectedOptions.push($(this).val());
  });

  // 2️⃣ Find matching variant
  const $select = $wrapper.find('select[name="product_variant_like"]');
  let matchedId = null;
  $select.find('option').each(function() {
    const variantOptions = $(this).data('options');
    if (variantOptions === selectedOptions.join('|')) {
      matchedId = $(this).val();
      $(this).prop('selected', true);
    }
  });

  // 3️⃣ Update AJAX add to cart button
  if (matchedId) {
    $wrapper.find('.ajax_add_to_cart').attr('variant_id', matchedId);
  } else {
    console.warn('No matching variant found for', selectedOptions.join('|'));
  }
});



$(document).on('click', '.ajax_add_to_cart', function(e) {
  e.preventDefault();

  const $btn = $(this).addClass('loading_hk');

  // Find the parent wrapper so it’s reusable
  const $wrapper = $btn.closest('.custom_options_selector_like');

  // Get the selected variant ID from the button’s attribute
  const variantId = $btn.attr('variant_id');

  if (!variantId) {
    alert('No variant selected!');
    $btn.removeClass('loading_hk');
    return;
  }

  const items = [{ id: variantId, quantity: 1 }];

  $.post({
    url: '/cart/add.js',
    data: JSON.stringify({ items }),
    dataType: 'json',
    contentType: 'application/json'
  }).done(() => {
    $.get(window.location.pathname, res => {
      refreshCartDrawer();
      $btn.removeClass('loading_hk');
  }).fail(xhr => {
    console.error('Add to cart failed', xhr.responseText);
    alert('There was an error adding your item.');
    $btn.removeClass('loading_hk');
  });
});
});







$(document).on("click", ".product_text_2 p em", function() {
$('.size_guide_popup').show();
});
$(document).on("click", ".product_text_gift p em", function() {
$('.size_guide_popup').show();
});



$(document).on("click", ".size_guide_popup .icon_with_text_flex .icon_with_text_item svg", function() {
$('.size_guide_popup').hide();
});




function refreshCartDrawer() {
  fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(data => {
      // Create a temporary DOM to parse the returned HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');

      // Get the updated CartDrawer content
      const newCartDrawerContent = doc.querySelector('#CartDrawer');
      const currentCartDrawer = document.querySelector('#CartDrawer');

      if (newCartDrawerContent && currentCartDrawer) {
        currentCartDrawer.innerHTML = newCartDrawerContent.innerHTML;
      }

      // Remove 'is-empty' class from <cart-drawer>
      const cartDrawerTag = document.querySelector('cart-drawer');
      if (cartDrawerTag) {
        cartDrawerTag.classList.remove('is-empty');
        cartDrawerTag.classList.add('active');
      }

      // Add 'overflow-hidden' to <body>
      document.body.classList.add('overflow-hidden');

    })
    .catch(err => console.error('Error refreshing cart drawer:', err));
}